import ApiIdentitiesList from './ApiIdentitiesList';
import ApiIdentitiesShow from './ApiIdentitiesShow';

export default {
  list: ApiIdentitiesList,
  show: ApiIdentitiesShow,
};
